/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryBookItemResponseModel from './CategoryBookItemResponseModel';
import OrganizationObjectDto from './OrganizationObjectDto';

/**
 * The OrganizationCategoryBookItemResponseModel model module.
 * @module model/OrganizationCategoryBookItemResponseModel
 * @version v1.0.0
 */
class OrganizationCategoryBookItemResponseModel {
    /**
     * Constructs a new <code>OrganizationCategoryBookItemResponseModel</code>.
     * @alias module:model/OrganizationCategoryBookItemResponseModel
     */
    constructor() { 
        
        OrganizationCategoryBookItemResponseModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrganizationCategoryBookItemResponseModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrganizationCategoryBookItemResponseModel} obj Optional instance to populate.
     * @return {module:model/OrganizationCategoryBookItemResponseModel} The populated <code>OrganizationCategoryBookItemResponseModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrganizationCategoryBookItemResponseModel();

            if (data.hasOwnProperty('organization')) {
                obj['organization'] = OrganizationObjectDto.constructFromObject(data['organization']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [CategoryBookItemResponseModel]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/OrganizationObjectDto} organization
 */
OrganizationCategoryBookItemResponseModel.prototype['organization'] = undefined;

/**
 * @member {Array.<module:model/CategoryBookItemResponseModel>} result
 */
OrganizationCategoryBookItemResponseModel.prototype['result'] = undefined;






export default OrganizationCategoryBookItemResponseModel;

